import { render, staticRenderFns } from "./BoxTipo.vue?vue&type=template&id=4875b232&scoped=true&"
import script from "./BoxTipo.vue?vue&type=script&lang=js&"
export * from "./BoxTipo.vue?vue&type=script&lang=js&"
import style0 from "./BoxTipo.vue?vue&type=style&index=0&id=4875b232&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4875b232",
  null
  
)

export default component.exports